<svg viewBox="0 0 30 30" version="1.1">

  <title>Menu</title>

  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g fill="#636769">
      <path d="M26,16 L4,16 C3.448,16 3,15.552 3,15 C3,14.448 3.448,14 4,14 L26,14 C26.552,14 27,14.448 27,15 C27,15.552 26.552,16 26,16 Z M26,9 L4,9 C3.448,9 3,8.552 3,8 C3,7.448 3.448,7 4,7 L26,7 C26.552,7 27,7.448 27,8 C27,8.552 26.552,9 26,9 Z M4,21 L26,21 C26.552,21 27,21.448 27,22 C27,22.552 26.552,23 26,23 L4,23 C3.448,23 3,22.552 3,22 C3,21.448 3.448,21 4,21 Z"></path>
    </g>
  </g>

</svg>

<span class="menu-text" translate>MENU</span>
